import { useDropzone } from 'react-dropzone';
import { Box, H4 } from '@bigcommerce/big-design';
import { PhotosList, PhotoLinksList } from '../pages/Orders/OrdersEditor/components/PhotosList';
import { UploadContainer } from '../pages/Orders/OrdersEditor/components/StyledComponents';
import { getDataUrlFromFile } from '../utils';

function FileRejectionItem({ file, errors }) {
	return (
		<li key={file.path}>
			{file.path} - {file.size} bytes
			<ul>
				{errors.map((e) => (
					<li key={e.code}>{e.message}</li>
				))}
			</ul>
		</li>
	);
}

function ImageDropzone({ photos, onAddPhotos, onRemovePhoto }) {
	const {
		getRootProps,
		getInputProps,
		fileRejections,
		isFocused,
		isDragAccept,
		isDragReject,
	} = useDropzone({
		accept: 'image/png,image/jpeg',
		maxSize: 1024 * 1024 * 10,
		onDrop: async (acceptedFiles) =>
			onAddPhotos(
				await Promise.all(
					[].map.call(acceptedFiles, getDataUrlFromFile),
				),
			),
	});

	return (
		<>
			<Box marginBottom="large">
				<UploadContainer
					{...getRootProps({ isFocused, isDragAccept, isDragReject })}
				>
					<div {...getRootProps({ className: 'dropzone' })}>
						<input {...getInputProps()} />
						{!isDragReject && (
							<p>
								Drop JPG or PNG Images Here or Click to Select
								Images
							</p>
						)}
						{isDragReject && (
							<p>Files must be a JPG or PNG image</p>
						)}
					</div>
				</UploadContainer>
				{fileRejections.length > 0 && (
					<Box marginTop="medium">
						<H4>Rejections:</H4>
						<ul>
							{fileRejections.map((props) => (
								<FileRejectionItem
									key={props.file.name}
									{...props}
								/>
							))}
						</ul>
					</Box>
				)}
			</Box>
			<PhotosList photos={photos} onRemovePhoto={onRemovePhoto} />
			<PhotoLinksList photos={photos} />
		</>
	);
}

export { ImageDropzone };
